import { ViewType } from '~/models/shared/types'
import { SearchConfig } from '~/models/search/config'

export const deletedSearchConfig: SearchConfig = Object.freeze({
  settings: {
    isDeletedSearch: true,
    viewType: {
      defaultViewTypeDesktop: ViewType.LIST,
      defaultViewTypeMobile: ViewType.LIST
    },
    searchName: 'deleted',
    searchbar: {
      autocompleteEndpoint: '/api/classifieds/deleted/query/',
      usesNuxtLinks: false
    }
  },
  rootParams: {
    sort: ['dld'],
    deletedonly: ['1'],
    category: [20001]
  }
})
